import * as toastr from "toastr";
import { IAPIResult } from "../Shared/Models/UtilityModels";
import { Utilities, ModalAction } from "../Shared/Utility/Utilities";
import { Carousel } from "bootstrap";
import { ModalPrompts, PredefinedModalEnum } from "../Shared/Utility/ModalPrompts";

(() => {
    document.addEventListener("DOMContentLoaded", function () {
        (<any>window).CAMSLibraryLink = CAMSLibraryLink;
    });
})();

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
}

export class CAMSLibraryLink {

    private _initialised: boolean = false;
    private _element: JQuery<HTMLElement>;
    private _loadingIndicator: JQuery<HTMLElement>;
    private _xgkey: string;
    private _xgtype: string;
    private _controllerRoute: string;
    private _action: string;
    private _modalElementID: string;
    private _onlyshowpublished: string;

    constructor(
        private _contentId = "llwsContent",
        private _loaderId = "llwsLoader"
    ) {
        this.init();
    }

    private init = () => {
        if (this._initialised) {
            return;
        }
        this._element = $(`[name="${this._contentId}"]`);
        this._loadingIndicator = $(`[name="${this._loaderId}"]`);
        this._xgkey = this._element.data("xgkey");
        this._xgtype = this._element.data("xgtype");
        this._controllerRoute = this._element.data("route");
        this._action = this._element.data("action");
        this._modalElementID = this._element.data("modalelementid");
        this._onlyshowpublished = this._element.data("onlyshowpublished");
        if (this._onlyshowpublished == "") this._onlyshowpublished = "false";
        this.LoadLlwsData();
        this._initialised = true;
    }

    private LoadLlwsData = (): void => {
        let self = this;
        self._loadingIndicator.show();
        var code: string = encodeURIComponent(self._xgkey);
        
        self._element.load(`/${self._controllerRoute}/${self._action}/${self._xgtype}/${code}/${self._onlyshowpublished}`, function (response, status, xhr) {
            //if (status == "error") {
            //    var msg = "Sorry but there was an error loading the library link images: ";
            //    $("#error").html(msg + xhr.status + " " + xhr.statusText);
            //}
            self._loadingIndicator.hide();

            // Modal close btn action
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalCloseBtn"]').on('click', function () {
                Utilities.GetModal('#camsLibraryLinkModal', ModalAction.Hide);
                if (self._modalElementID != null) Utilities.UnBlockUI($('#' + self._modalElementID));
            });

            // Prev and next btns
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalPrevBtn"]').on('click', function () {
                ($('#camsLibraryLinkModalGallery') as any).carousel('prev');
            });
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalNextBtn"]').on('click', function () {
                ($('#camsLibraryLinkModalGallery') as any).carousel('next');
            });

            // Trash btn
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalDeleteBtn"]').on('click', function () {
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                    if (r.yes == true) {
                        doDelete();
                    }
                    else {
                    }
                }).catch(e => { });

                function doDelete() {
                    var total = $('#camsLibraryLinkModalGallery .carousel-item').length;
                    var thumbid = $('#camsLibraryLinkModalGallery .carousel-item.active').data('thumbid');

                    if (total == 1) {
                        $('#camsLibraryLinkContainer [data-thumbid="' + thumbid + '"]').remove();
                        Utilities.GetModal('#camsLibraryLinkModal', ModalAction.Hide);
                        if (self._modalElementID != null) Utilities.UnBlockUI($('#' + self._modalElementID));
                    }
                    else {
                        var currentIndex = $('#camsLibraryLinkModalGallery .carousel-item.active').index();
                        $('#camsLibraryLinkModalGallery .carousel-item.active').remove();
                        $('#camsLibraryLinkContainer [data-thumbid="'+thumbid+'"]').remove();

                        $('#camsLibraryLinkModalGallery .carousel-item').first().addClass('active');
                        var total = $('#camsLibraryLinkModalGallery .carousel-item').length;
                        $('#camsLibraryLinkModal [name="camsLibraryLinkModalCurrentCountMsg"]').html("Showing 1 of " + total);
                    }

                    self.DeleteAsset(thumbid,self._xgtype,self._xgkey, null);
                }
            });
       
            $('#camsLibraryLinkContainer [name="deleteIcon"]').on('click', function () {
                var currentEl = $(this);
                var thumbid = $(this).parent().data("thumbid");

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                    if (r.yes == true) {
                        doDelete(thumbid);
                    }
                    else {
                    }
                }).catch(e => { });

                function doDelete(thumbid) {
                    self.DeleteAsset(thumbid, self._xgtype, self._xgkey, function (r) { currentEl.parent().remove(); });
                }
            });

            // Rotate Btn
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalRotateBtn"]').on('click', function () {
                var img = $('#camsLibraryLinkModalGallery .carousel-item.active img');
                if (img.data('rotated')=="0") {
                    img.css('transform', 'rotate(90deg) scale(50%)');
                    img.data('rotated', "90");
                }
                else if (img.data('rotated') == "90") {
                    img.css('transform', 'rotate(180deg)');
                    img.data('rotated', "180");
                }
                else if (img.data('rotated') == "180") {
                    img.css('transform', 'rotate(270deg)  scale(50%)');
                    img.data('rotated', "270");
                }
                else if (img.data('rotated') == "270") {
                    img.css('transform', 'none');
                    img.data('rotated', "0");
                }
                toastr.info("To be completed");
            });

            // publish checkbox
            $('#camsLibraryLinkModal [name="publishPhotoCheckbox"]').each(function () {
                var okforweb = $(this).data("okforweb");
                if (okforweb == "Y" || okforweb == "1") $(this).prop('checked', true);
            });

            // Save Btn
            $('#camsLibraryLinkModal [name="camsLibraryLinkModalSaveBtn"]').on('click', function () {
                var thumbid = $('#camsLibraryLinkModalGallery .carousel-item.active').data('thumbid');
                var annotation = $('#camsLibraryLinkModalGallery .carousel-item.active [name="annotation"]').val().toString();
                var person = $('#camsLibraryLinkModalGallery .carousel-item.active [name="person"]').val().toString();
                var linkDate = $('#camsLibraryLinkModalGallery .carousel-item.active [name="LinkDate"]').val().toString();
                var origDate = $('#camsLibraryLinkModalGallery .carousel-item.active [name="OrigDate"]').val().toString();

                // Update okforweb
                var okforwebEl = $('#camsLibraryLinkModalGallery .carousel-item.active [data-okforweb]');
                if (okforwebEl.data('okforweb') == "Y" && okforwebEl.is(":checked") == false) {
                    self.UpdateField(thumbid, "okforweb", "0", null);
                }
                else if (okforwebEl.data('okforweb') != "Y" && okforwebEl.is(":checked") == true) {
                    self.UpdateField(thumbid, "okforweb", "1", null);
                }

                // Update annottion
                self.UpdateField(thumbid, "annotation", annotation, null);
                self.UpdateField(thumbid, "uf_Compiler", person, null);
                self.UpdateField(thumbid, "uf_Original_DateTime", origDate, null);
                self.UpdateField(thumbid, "uf_CompilationDate", linkDate, null);

                // Close form
                Utilities.GetModal(null, ModalAction.Hide, $('#camsLibraryLinkModal'));
                if (self._modalElementID != null) Utilities.UnBlockUI($('#' + self._modalElementID));
            });

            // Open the modal when the card is clicked
            $('#camsLibraryLinkContainer [data-thumbid]').on('click', function () {
                var index = $('#camsLibraryLinkContainer [data-thumbid]').index($(this));
                //var index = $(this).data('slide');
                ($('#camsLibraryLinkModalGallery') as any).carousel(index);

                var total = $('#camsLibraryLinkModalGallery .carousel-item').length;
                $('#camsLibraryLinkModal [name="camsLibraryLinkModalCurrentCountMsg"]').html("Showing " + (index + 1) + " of " + total);

                if (self._modalElementID != null) Utilities.BlockUI($('#' + self._modalElementID));
                Utilities.GetModal(null, ModalAction.Create, $('#camsLibraryLinkModal'));
            });

            // Update the display after the slide animation finishes
            $('#camsLibraryLinkModalGallery').on('slid.bs.carousel', function () {
                var total = $('#camsLibraryLinkModalGallery .carousel-item').length;
                var currentIndex = $('#camsLibraryLinkModalGallery .carousel-item.active').index() + 1;
                $('#camsLibraryLinkModal [name="camsLibraryLinkModalCurrentCountMsg"]').html("Showing " + currentIndex + " of " + total);
            });
        });
    }

    private UpdateField = (resourceId: number, fieldId: string, value: string, callback: Function): void => {
        let self = this;

        let url = "/CAMSLibraryLink/UpdateFieldOnLibraryLinkAsset";
        let query = { resourceId: resourceId, fieldId: fieldId, value: value };

        Utilities.BlockUI();
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        //toastr.success("Updated asset.");
                        if (callback != null) callback.call(true);
                    }
                    else {
                        toastr.error('Failed to update asset!')
                        if (callback != null) callback.call(false);
                    }
                }
                catch (err) {
                    console.log(err);
                    if (callback != null) callback.call(false);
                }
                finally {
                    Utilities.UnBlockUI();
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private DeleteAsset = (resourceId: number, xgtype:string,xgkey:string, callback: Function): void => {
        let self = this;

        let url = "/CAMSLibraryLink/DeleteLibraryLinkAsset";
        let query = { resourceId: resourceId,xgtype:xgtype,xgkey:xgkey };

        Utilities.BlockUI();
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.success("Deleted asset.");
                        if (callback != null) callback.call(true);
                    }
                    else {
                        toastr.error('Failed to delete asset!')
                        if (callback != null) callback.call(false);
                    }
                }
                catch (err) {
                    console.log(err);
                    if (callback != null) callback.call(false);
                }
                finally {
                    Utilities.UnBlockUI();
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}
